import React from 'react'

import BugManager from '../components/bug-report/manager'

class BugsPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<BugManager />
			</div>
		)
	}

}

export default BugsPage;


// WEBPACK FOOTER //
// ./src/containers/bugs-page.js